import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

enum ToastrClass {
    DEFAULT = 'ngx-toastr',
    ERROR = 'toast-error ngx-toastr',
    SUCCESS = 'toast-success ngx-toastr',
    WARNING = 'toast-warning ngx-toastr',
}

export enum ToastrStatus {
    DEFAULT = 'DEFAULT',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
}

export class ToasterMessage {
    status?: ToastrStatus;
    text: string;
    title?: string;
}

// TODO: At some point we want to move this service into captiveaire package so we can distribute it over multiple parts of app at once.

@Injectable({
    providedIn: 'root',
})
export class ToastrMainService {
    private readonly defaultToastrConfiguration: Partial<IndividualConfig> = {
        positionClass: 'toast-bottom-full-width',
        tapToDismiss: false,
        closeButton: true,
        timeOut: 4000,
        extendedTimeOut: 180 * 1000,
        progressBar: true,
        progressAnimation: 'decreasing',
    };

    constructor(
        private toastrService: ToastrService,
    ) {}

    show(message: ToasterMessage, customToastrConfiguration?: Partial<IndividualConfig>) {
        const { text, title, status } = message;
        return this.toastrService.show(text, title, {
            ...this.defaultToastrConfiguration,
            toastClass: ToastrClass[status],
            ...customToastrConfiguration,
        });
    }

    close(toastId: number) {
        this.toastrService.clear(toastId);
    }
}
